module.exports = __webpack_public_path__ + "static/media/reception-6.73844d4f.jpg";